import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderButtonComponent } from './loader-button.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LoaderButtonComponent],
  exports: [LoaderButtonComponent]
})
export class LoaderButtonModule {}
